module.exports = __webpack_public_path__ + "img/qaBanner.ee6617d7.jpg";